import type { TFunction } from 'i18next';
import { IconButton, Edit } from 'qampo-ui-library';
import TrashIcon from '../../assets/icons/trash.svg?react';
import type { UserDetailResponse } from '../../api/generated';
import type { TableColumn } from '../UI';
import styles from './UsersSettings.module.css';

interface UserColumnCallbacks {
  onEdit: (user: UserDetailResponse) => void;
  onDelete: (user: UserDetailResponse) => void;
}

export const getUserColumns = (
  t: TFunction,
  { onEdit, onDelete }: UserColumnCallbacks
): TableColumn<UserDetailResponse>[] => [
  {
    key: 'name',
    header: t('config-user-col-name'),
    render: (user) => (
      <span className={styles.nameCell}>{`${user.firstName} ${user.lastName}`.trim()}</span>
    )
  },
  {
    key: 'email',
    header: t('config-user-col-email'),
    render: (user) => <span className={styles.emailCell}>{user.email}</span>
  },
  {
    key: 'accountAdmin',
    header: t('config-user-col-admin'),
    width: 150,
    headerAlign: 'center',
    cellStyle: { justifyContent: 'center' },
    render: (user) =>
      user.accountAdmin ? (
        <span className={`${styles.badge} ${styles.badgeOn}`}>{t('config-user-admin-yes')}</span>
      ) : (
        <span className={`${styles.badge} ${styles.badgeOff}`}>{t('config-user-admin-no')}</span>
      )
  },
  {
    key: 'actions',
    header: '',
    width: 100,
    headerAlign: 'center',
    render: (user) => (
      <div className={styles.rowActions}>
        <IconButton
          size="small"
          icon={<Edit width={14} height={14} />}
          onClick={() => onEdit(user)}
          classes={styles.actionBtn}
        />
        <IconButton
          size="small"
          icon={<TrashIcon width={14} height={14} />}
          onClick={() => onDelete(user)}
          classes={`${styles.actionBtn} ${styles.actionBtnDelete}`}
        />
      </div>
    )
  }
];
